import leadInstance from "./axios-instances/lead";

export function fetchMeetings(data) {
    const params = new URLSearchParams(data);
    return leadInstance.get(`/meetings?${params.toString()}`);
}

export function createMeeting(meetingData) {
    return leadInstance.post("/meetings", meetingData);
}

export function updateMeeting(meetingID, updates) {
    return leadInstance.put(`/meetings/${meetingID}`, updates);
}

export function registerEventAndMarkAttendance(payload) {
    return leadInstance.post("/record", payload);
}

export function sendDocsToWhatsApp(payload) {
    return leadInstance.post("/meetings/trigger_whatsapp", payload);
}
